/**
 * App Designer Routes Configuration
 *
 * This file contains all route definitions for the App Designer module.
 * Routes are organized by feature/module for better maintainability.
 */

import React, { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

// Pages
const AppDesignerHome = lazy(() => import('../pages/AppDesignerHome'));
const ThemesPage = lazy(() => import('../../../../pages/Themes'));

// Modules - Lazy loaded for better performance
const WorkflowDesignerPage = lazy(() => import('../modules/workflow-designer'));
const ModuleManagementPage = lazy(() => import('../modules/module-management/ModuleManagementPage'));
const DataModelerPage = lazy(() => import('../modules/db-designer'));
const FormBuilderPage = lazy(() => import('../modules/form-builder'));
const PdfEditorPage = lazy(() => import('../modules/pdf-editor'));
const TemplateListPage = lazy(() => import('../modules/template-list'));
const ConnectionsPage = lazy(() => import('../modules/connection-settings'));
const ProjectsPage = lazy(() => import('../modules/projects'));
const ProjectDetailPage = lazy(() => import('../modules/projects/ProjectProfile'));
const JobMonitorPage = lazy(() => import('../modules/job-monitor'));
const DevTeamPage = lazy(() => import('../modules/ai-agents'));
const DashboardBuilderPage = lazy(() => import('../modules/dashboard-builder'));
const ApiManagementPage = lazy(() => import('../modules/api-management'));
const ReportBuilderPage = lazy(() => import('../modules/report-builder'));
const AppStoreAdminPage = lazy(() => import('../../appstore-admin/dashboards/AdminDashboard'));
const CreateAppPage = lazy(() => import('../../appstore-admin/pages/CreateApp'));
const FileStoreManagementPage = lazy(() => import('../modules/filestore-management'));
const NotificationsManagementPage = lazy(() => import('../modules/notifications-management'));
const TenantManagementPage = lazy(() => import('../modules/tenant-management'));

// Route definitions for App Designer module
export const appDesignerRoutes: RouteObject[] = [
  {
    index: true,
    element: <AppDesignerHome />
  },
  {
    path: 'workflow-designer',
    element: <WorkflowDesignerPage />
  },
  {
    path: 'module-management',
    element: <ModuleManagementPage />
  },
  {
    path: 'data-modeler',
    element: <DataModelerPage />
  },
  {
    path: 'form-designer',
    element: <FormBuilderPage />
  },
  {
    path: 'form-builder',
    element: <FormBuilderPage />
  },
  {
    path: 'pdf-editor',
    element: <PdfEditorPage />
  },
  {
    path: 'template-list',
    element: <TemplateListPage />
  },
  {
    path: 'connection-settings',
    element: <ConnectionsPage />
  },
  {
    path: 'connections',
    element: <ConnectionsPage />
  },
  {
    path: 'projects',
    element: <ProjectsPage />
  },
  {
    path: 'projects/:projectId',
    element: <ProjectDetailPage />
  },
  {
    path: 'job-builder',
    element: <WorkflowDesignerPage />
  },
  {
    path: 'job-monitor',
    element: <JobMonitorPage />
  },
  {
    path: 'dev-team',
    element: <DevTeamPage />
  },
  {
    path: 'dashboard-builder',
    element: <DashboardBuilderPage />
  },
  {
    path: 'api-management',
    element: <ApiManagementPage />
  },
  {
    path: 'reports-designer',
    element: <ReportBuilderPage />
  },
  {
    path: 'themes',
    element: <ThemesPage />
  },
  {
    path: 'appstore-admin',
    element: <AppStoreAdminPage />
  },
  {
    path: 'appstore-admin/create-app',
    element: <CreateAppPage />
  },
  {
    path: 'filestore-management',
    element: <FileStoreManagementPage />
  },
  {
    path: 'notifications-management',
    element: <NotificationsManagementPage />
  },
  {
    path: 'tenant-management',
    element: <TenantManagementPage />
  }
];

export default appDesignerRoutes;
